import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import moment from "moment";
import _ from 'lodash';
import 'moment-timezone';
import { dateAccessHelper } from '../helpers/accessHelper';
import { spaceToUnderscore } from '../helpers/helpers';
import CalendarDialogLink from '../dialogs/CalendarDialogLink';
import ConfirmLink from 'react-confirm-dialog';
import Toggle from 'react-bootstrap-toggle';
import * as types from "../constants/actionTypes";
import DateTime from 'react-datetime';

const timezone = 'America/New_York';
const format = 'YYYY-MM-DD HH:mm:ss';

class InstructorHomeView extends Component {

    constructor(props) {
        super (props);
        this.state = {
            show_index: props.dropbox.show_index,
            assignment: {
                access_open_date: null,
                access_close_date: null,
                students_per_group_max: null,
                students_per_group_min: null,
            }
        };

        this.handleShowIndexChange = this.handleShowIndexChange.bind(this);
        this.getCalendarDialogConfirmMessage = this.getCalendarDialogConfirmMessage.bind(this);
        this.handleAssignmentCloseDateChange = this.handleAssignmentCloseDateChange.bind(this);
        this.handleAssignmentOpenDateChange = this.handleAssignmentOpenDateChange.bind(this);
        this.handleUploadCloseDateChange = this.handleUploadCloseDateChange.bind(this);
        this.handleUploadOpenDateChange = this.handleUploadOpenDateChange.bind(this);
        this.resetCalendarDialog = this.resetCalendarDialog.bind(this);
        this.updateAssignmentHandler = this.updateAssignmentHandler.bind(this);
        this.getDateErrors = this.getDateErrors.bind(this);
    }

    toggleAssignmentAccess(assignment) {
        if (!this.props.request.sendingRequest) {
            const formatted_assignment = {
                ...assignment,
                access_enabled: !assignment.access_enabled
            };

            this.props.dispatch({
                type: types.ASSIGNMENT__UPDATE__REQUESTED,
                payload: {
                    assignment: {
                        ...formatted_assignment,
                        dropbox: assignment.dropbox.id,
                    },
                    assignmentName: assignment.name,
                    dropboxName: assignment.dropbox.name,
                    reload: false,
                }
            });
        }
    }

    toggleUploadAccess(assignment) {
        if (!this.props.request.sendingRequest) {
            const formatted_assignment = {
                ...assignment,
                submission_enabled: !assignment.submission_enabled
            };

            this.props.dispatch({
                type: types.ASSIGNMENT__UPDATE__REQUESTED,
                payload: {
                    assignment: {
                        ...formatted_assignment,
                        dropbox: assignment.dropbox.id,
                    },
                    assignmentName: assignment.name,
                    dropboxName: assignment.dropbox.name,
                    reload: false,
                }
            });
        }
    }

    resetCalendarDialog() {
        this.setState({
            assignment: null,
            errors: null,
        });
    }

    handleAssignmentOpenDateChange(value) {
        value = moment(value).format('YYYY-MM-DD HH:mm:ss');
        this.setState({
            assignment: {
                ...this.state.assignment,
                access_open_date: value
            }
        });
    }

    handleAssignmentCloseDateChange(value) {
        value = moment(value).format('YYYY-MM-DD HH:mm:ss');
        this.setState({
            assignment: {
                ...this.state.assignment,
                access_close_date: value
            }
        });
    }

    handleUploadOpenDateChange(value) {
        value = moment(value).format('YYYY-MM-DD HH:mm:ss');
        this.setState({
            assignment: {
                ...this.state.assignment,
                submission_open_date: value
            }
        });
    }

    handleUploadCloseDateChange(value) {
        value = moment(value).format('YYYY-MM-DD HH:mm:ss');
        this.setState({
            assignment: {
                ...this.state.assignment,
                submission_close_date: value
            }
        });
    }

    handleShowIndexChange(dropbox, show_index) {
        this.setState({
            show_index: show_index
        });

        const formatted_dropbox = {
            id: dropbox.id,
            course : dropbox.course.id,
            semester: dropbox.semester.id,
            name : dropbox.name,
            runscript_url : dropbox.runscript_url,
            runscript_port : dropbox.runscript_port,
            show_index: show_index,
        };

        this.props.dispatch({
            type: types.DROPBOXES__UPDATE__SHOW_INDEX__REQUESTED,
            payload: {
                dropbox: formatted_dropbox,
            }
        });
    }

    validateAssignment(assignment) {
        const errors = _.union(
            this.getDateErrors(assignment),
        );

        this.setState({ errors });

        return errors.length < 1;
    }

    getDateErrors(assignment) {
        const {
                access_close_date, access_open_date,
                submission_close_date, submission_open_date,
                use_date_control
            } = assignment
        ;

        let date_errors = [];

        if (use_date_control) {
            if (moment(access_open_date).isAfter(moment(submission_open_date))) {
                date_errors.push("Assignment Accessible Open Date must be same or before File Uploads Open Date.");
            }

            if (moment(submission_open_date).isSameOrAfter(moment(submission_close_date))) {
                date_errors.push("File Uploads Close Date must be after File Uploads Open Date.");
            }

            if (moment(access_open_date).isSameOrAfter(moment(access_close_date))) {
                date_errors.push("Assignment Accessible Close Date must be after Assignment Accessible Open Date.");
            }

            if (moment(submission_close_date).isAfter(moment(access_close_date))) {
                date_errors.push("File Uploads Close Date must be same or before Assignment Accessible Close Date.");
            }
        }

        return date_errors;
    }

    updateAssignmentHandler(actionArgs) {
        const { assignment } = actionArgs,
            formatted_assignment = {
                ...assignment,
                submission_open_date:
                    this.state.assignment && this.state.assignment.submission_open_date
                    ? this.state.assignment.submission_open_date
                    : moment(assignment.submission_open_date).tz(timezone).format(format),
                submission_close_date:
                    this.state.assignment && this.state.assignment.submission_close_date
                    ? this.state.assignment.submission_close_date
                    : moment(assignment.submission_close_date).tz(timezone).format(format),
                access_open_date:
                    this.state.assignment && this.state.assignment.access_open_date
                    ? this.state.assignment.access_open_date
                    : moment(assignment.access_open_date).tz(timezone).format(format),
                access_close_date:
                    this.state.assignment && this.state.assignment.access_close_date
                    ? this.state.assignment.access_close_date
                    : moment(assignment.access_close_date).tz(timezone).format(format),
            }
        ;

        if (!this.validateAssignment(formatted_assignment)){
            return false;
        }

        this.props.dispatch({
            type: types.ASSIGNMENT__UPDATE__REQUESTED,
            payload: {
                assignment: {
                    ...formatted_assignment,
                    dropbox: assignment.dropbox.id,
                },
                assignmentName: assignment.name,
                dropboxName: assignment.dropbox.name,
                reload: false,
            }
        });
    }

    getCalendarDialogConfirmMessage(assignment) {
        return (
            <div>
                {
                    _.map(this.state.errors,(error) => {
                        return (
                            <div className="alert alert-danger alert-dismissible" role="alert">
                                {error}
                            </div>
                        );
                    })
                }
                <label>Assignment Accessible Open Date</label>
                <br />
                <div className="input-group col-md-12">
                    <div className="input-group-addon">
                        <i className="fa fa-calendar" />
                    </div>
                    <DateTime
                        dateFormat="YYYY-MM-DD"
                        closeOnSelect={true}
                        timeFormat="HH:mm:ss"
                        inputProps={{
                            name: "assignment_open_date",
                            readOnly: true
                        }}
                        value={
                            this.state.assignment && this.state.assignment.access_open_date
                            ? moment(this.state.assignment.access_open_date).tz(timezone).format(format)
                            : moment(assignment.access_open_date).tz(timezone).format(format)
                        }
                        onChange={this.handleAssignmentOpenDateChange}
                        required
                    />
                </div>
                <label>File Uploads Open Date</label>
                <br />
                <div className="input-group col-md-12">
                    <div className="input-group-addon">
                        <i className="fa fa-calendar" />
                    </div>
                    <DateTime
                        dateFormat="YYYY-MM-DD"
                        closeOnSelect={true}
                        timeFormat="HH:mm:ss"
                        inputProps={{
                            name: "assignment_open_date",
                            readOnly: true
                        }}
                        value={
                            this.state.assignment && this.state.assignment.submission_open_date
                            ? moment(this.state.assignment.submission_open_date).tz(timezone).format(format)
                            : moment(assignment.submission_open_date).tz(timezone).format(format)
                        }
                        onChange={this.handleUploadOpenDateChange}
                        required
                    />
                </div>
                <label>File Uploads Close Date</label>
                <br />
                <div className="input-group col-md-12">
                    <div className="input-group-addon">
                        <i className="fa fa-calendar" />
                    </div>
                    <DateTime
                        dateFormat="YYYY-MM-DD"
                        closeOnSelect={true}
                        timeFormat="HH:mm:ss"
                        inputProps={{
                            name: "assignment_open_date",
                            readOnly: true
                        }}
                        value={
                            this.state.assignment && this.state.assignment.submission_close_date
                            ? moment(this.state.assignment.submission_close_date).tz(timezone).format(format)
                            : moment(assignment.submission_close_date).tz(timezone).format(format)
                        }
                        onChange={this.handleUploadCloseDateChange}
                        required
                    />
                </div>
                <label>Assignment Accessible Close Date</label>
                <br />
                <div className="input-group col-md-12">
                    <div className="input-group-addon">
                        <i className="fa fa-calendar" />
                    </div>
                    <DateTime
                        dateFormat="YYYY-MM-DD"
                        closeOnSelect={true}
                        timeFormat="HH:mm:ss"
                        inputProps={{
                            name: "assignment_open_date",
                            readOnly: true
                        }}
                        value={
                            this.state.assignment && this.state.assignment.access_close_date
                            ? moment(this.state.assignment.access_close_date).tz(timezone).format(format)
                            : moment(assignment.access_close_date).tz(timezone).format(format)
                        }
                        onChange={this.handleAssignmentCloseDateChange}
                        required
                    />
                </div>
                <br/>
            </div>
        );
    }

    render() {
        const { assignments, dropbox, expanded, deleteAssignmentHandler, semesters } = this.props;

        let semester = semesters[dropbox.semester.id];

        return (
            <div className="card" key={dropbox.id}>
                <div className="card-header" role="tab">
                    <h5 className="mb-0">
                        <Link
                            data-toggle="collapse"
                            to={'#collapse' + dropbox.id}
                            aria-expanded="true"
                            aria-controls={'collapse' + dropbox.id}
                            onlyActiveOnIndex={false}
                        >
                            <i className="fa fa-book" aria-hidden="true"/>&nbsp;
                            {dropbox.name}
                            <span className="float-right">
                                <span className="mr-2"/>
                                <span>
                                    {semester.season}
                                </span>
                                -
                                <span>
                                    {semester.year}
                                </span>
                            </span>
                        </Link>
                        <Link
                            className="btn-sm small float-right"
                            to={`/dropbox/${dropbox.id}/users`}
                            onlyActiveOnIndex={false}
                        >
                            <i className="fa fa-user"/> Enrollment
                        </Link>
                    </h5>
                </div>
                <div
                    id={'collapse' + dropbox.id}
                    className={parseInt(expanded) === parseInt(dropbox.id) ? 'show' : 'collapse'}
                    role="tabpanel"
                    aria-labelledby={'heading' + dropbox.id}
                >
                    <div className="card-block">
                        <span className="float-right mb-2">
                            <div className="btn-group" role="group">
                                <button
                                    type="button"
                                    className="btn btn-default btn-sm"
                                    data-toggle="dropdown"
                                    aria-expanded="false"
                                    style={this.state.show_index === 0  ? {'minWidth':'250px'} : {'display':'none'}}
                                >
                                    <span title="Assignment Index Hidden From Students">
                                        <i className="fa fa-eye-slash"/> Index Hidden From Students
                                    </span>
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-warning btn-sm"
                                    data-toggle="dropdown"
                                    aria-expanded="false"
                                    style={this.state.show_index === 1 ? {'minWidth':'250px'} : {'display':'none'}}
                                >
                                    <span title="Assignment Index Visible To Students. Show Accessible Assignments Only">
                                        <i className="fa fa-eye"/> Index Visible (Show Accessible)
                                    </span>
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-success btn-sm"
                                    data-toggle="dropdown"
                                    aria-expanded="false"
                                    style={this.state.show_index === 2 ? {'minWidth':'250px'} : {'display':'none'}}
                                >
                                    <span title="Assignment Index Visible To Students. Show All Assignments">
                                        <i className="fa fa-eye"/> Index Visible (Show All)
                                    </span>
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-secondary btn-sm dropdown-toggle dropdown-toggle-split"
                                    data-toggle="dropdown" aria-expanded="false"
                                >
                                    <span className="sr-only">Toggle Dropdown</span>
                                </button>
                                <div className="dropdown-menu">
                                    <button
                                        type="button"
                                        className="btn btn-default btn-sm m-2"
                                        style={this.state.show_index !== 0 ? {'minWidth':'250px'} : {'display':'none'}}
                                        onClick={() => this.handleShowIndexChange(dropbox, 0)}
                                    >
                                        <div title="Assignment Index Hidden From Students">
                                            <i className="fa fa-eye-slash"/> Index Hidden From Students
                                        </div>
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-warning btn-sm m-2"
                                        style={this.state.show_index !== 1  ? {'minWidth':'250px'} : {'display':'none'}}
                                        onClick={() => this.handleShowIndexChange(dropbox, 1)}
                                    >
                                        <div title="Assignment Index Visible To Students. Show Accessible Assignments Only">
                                            <i className="fa fa-eye"/> Index Visible (Show Accessible)
                                        </div>
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-success btn-sm m-2"
                                        style={this.state.show_index !== 2  ? {'minWidth':'250px'} : {'display':'none'}}
                                        onClick={() => this.handleShowIndexChange(dropbox, 2)}
                                    >
                                        <div title="Assignment Index Visible To Students. Show All Assignments">
                                            <i className="fa fa-eye"/> Index Visible (Show All)
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </span>
                        {
                            _.size(assignments) > 0
                            ? (
                                <span className="float-right mb-2 mr-2">
                                    <Link
                                        className="btn btn-info btn-sm"
                                        to={`/${dropbox.name}/assignments/copy`}
                                        onlyActiveOnIndex={false}
                                    >
                                        <i className="fa fa-files-o"/> Copy All Assignments
                                    </Link>
                                </span>
                            ) : null
                        }
                        <table className="table course-list">
                            <thead>
                            <tr className="course-list-header">
                                <th>Assignment</th>
                                <th>Due Date</th>
                                <th>Access</th>
                                <th>Upload</th>
                                <th>Type</th>
                                <th>Edit</th>
                                <th>Copy</th>
                                <th>Delete</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                _.map(_.sortBy(assignments, ['due_date', 'name']), (assignment) => {
                                    let isAccessible = false;
                                    (
                                        assignment.use_date_control
                                        ? isAccessible = dateAccessHelper(assignment.access_open_date, assignment.access_close_date)
                                        : [assignment.access_enabled
                                            ? isAccessible = true
                                            : isAccessible = false
                                        ]
                                    );
                                    let isUploadAllowed = false;
                                    (
                                        assignment.use_date_control
                                            ? isUploadAllowed  = dateAccessHelper(assignment.submission_open_date, assignment.submission_close_date)
                                            : [assignment.submission_enabled
                                                ? isUploadAllowed  = true
                                                : isUploadAllowed  = false
                                            ]
                                    );
                                    return (
                                        <tr key={assignment.id}>
                                            <td>
                                                <Link
                                                    to={`/${dropbox.name}/${spaceToUnderscore(assignment.name)}`}
                                                    onlyActiveOnIndex={false}
                                                >
                                                    {assignment.name}
                                                </Link>
                                            </td>
                                            <td>
                                                {moment(assignment.due_date).tz(timezone).format('MM-DD-YYYY h:mm:ss a')}
                                            </td>
                                            <td>
                                                {
                                                    assignment.use_date_control
                                                    ? [
                                                        isAccessible
                                                        ?
                                                            <CalendarDialogLink
                                                                action={this.updateAssignmentHandler}
                                                                actionArgs={{
                                                                    dropbox: dropbox,
                                                                    assignment: assignment,
                                                                }}
                                                                asHtml={true}
                                                                assignment={assignment}
                                                                confirmMessage={this.getCalendarDialogConfirmMessage}
                                                                confirmText={"Save"}
                                                                cancelText={"Cancel"}
                                                                reset={this.resetCalendarDialog}
                                                                request={this.props.request}
                                                            >
                                                                <i
                                                                    title="Assignment Accessible"
                                                                    key={assignment.id}
                                                                    className="assignment-green btn fa fa-calendar"
                                                                    aria-hidden="true"
                                                                />
                                                            </CalendarDialogLink>
                                                        :
                                                            <CalendarDialogLink
                                                                action={this.updateAssignmentHandler}
                                                                actionArgs={{
                                                                    dropbox: dropbox,
                                                                    assignment: assignment,
                                                                }}
                                                                asHtml={true}
                                                                assignment={assignment}
                                                                confirmMessage={this.getCalendarDialogConfirmMessage}
                                                                confirmText={"Save"}
                                                                cancelText={"Cancel"}
                                                                reset={this.resetCalendarDialog}
                                                                request={this.props.request}
                                                            >
                                                                <i
                                                                    title="Assignment Not Accessible"
                                                                    key={assignment.id}
                                                                    className="assignment-red btn fa fa-calendar"
                                                                    aria-hidden="true"
                                                                />
                                                            </CalendarDialogLink>
                                                    ] : [
                                                        <Toggle
                                                            onClick={() => this.toggleAssignmentAccess(assignment)}
                                                            name="toggle_assignment"
                                                            className="assignment-access"
                                                            size="xs"
                                                            on={<i title="Assignment Accessible" key={assignment.id} className="assignment-green btn fa fa-check" aria-hidden="true" />}
                                                            off={<i title="Assignment Not Accessible" key={assignment.id} className="assignment-red btn fa fa-minus-circle" aria-hidden="true" />}
                                                            handlestyle="none"
                                                            offstyle="none"
                                                            onstyle="none"
                                                            active={assignment.access_enabled}
                                                            key={assignment.id}
                                                        />
                                                    ]
                                                }
                                            </td>
                                            <td>
                                                {
                                                    assignment.use_date_control
                                                    ? [
                                                        isUploadAllowed
                                                        ?
                                                            <CalendarDialogLink
                                                                action={this.updateAssignmentHandler}
                                                                actionArgs={{
                                                                    dropbox: dropbox,
                                                                    assignment: assignment,
                                                                }}
                                                                asHtml={true}
                                                                assignment={assignment}
                                                                confirmMessage={this.getCalendarDialogConfirmMessage}
                                                                confirmText={"Save"}
                                                                cancelText={"Cancel"}
                                                                reset={this.resetCalendarDialog}
                                                                request={this.props.request}
                                                            >
                                                                <i
                                                                    title="Upload Allowed"
                                                                    key={assignment.id}
                                                                    className="assignment-green btn fa fa-calendar"
                                                                    aria-hidden="true"
                                                                />
                                                            </CalendarDialogLink>
                                                        :
                                                            <CalendarDialogLink
                                                                action={this.updateAssignmentHandler}
                                                                actionArgs={{
                                                                    dropbox: dropbox,
                                                                    assignment: assignment,
                                                                }}
                                                                asHtml={true}
                                                                assignment={assignment}
                                                                confirmMessage={this.getCalendarDialogConfirmMessage}
                                                                confirmText={"Save"}
                                                                cancelText={"Cancel"}
                                                                reset={this.resetCalendarDialog}
                                                                request={this.props.request}
                                                            >
                                                                <i
                                                                    title="Upload Not Allowed"
                                                                    key={assignment.id}
                                                                    className="assignment-red btn fa fa-calendar"
                                                                    aria-hidden="true"
                                                                />
                                                            </CalendarDialogLink>
                                                    ] : [
                                                        <Toggle
                                                            onClick={() => this.toggleUploadAccess(assignment)}
                                                            name="toggle_assignment"
                                                            className="assignment-access"
                                                            size="xs"
                                                            on={<i title="Upload Allowed" key={assignment.id} className="assignment-green btn fa fa-check" aria-hidden="true" />}
                                                            off={<i title="Upload Not Allowed" key={assignment.id} className="assignment-red btn fa fa-minus-circle" aria-hidden="true" />}
                                                            handlestyle="none"
                                                            offstyle="none"
                                                            onstyle="none"
                                                            active={assignment.submission_enabled}
                                                            key={assignment.id}
                                                        />
                                                    ]
                                                }
                                            </td>
                                            <td>
                                                {
                                                    assignment.group_submission
                                                    ? (
                                                        <span>
                                                            <Link
                                                                to={`/${dropbox.name}/${spaceToUnderscore(assignment.name)}/groups`}
                                                                onlyActiveOnIndex={false}
                                                            >
                                                                <i
                                                                    title="Group Assignment"
                                                                    className="fa fa-users"
                                                                    aria-hidden="true"
                                                                />
                                                            </Link>
                                                        </span>
                                                    ) : (
                                                        <i
                                                            title="Individual Assignment"
                                                            className="fa fa-user"
                                                            aria-hidden="true"
                                                        />
                                                    )
                                                }
                                            </td>
                                            <td>
                                                <Link
                                                    to={`/${dropbox.name}/${spaceToUnderscore(assignment.name)}/edit`}
                                                    onlyActiveOnIndex={false}
                                                >
                                                    <i
                                                        title="Edit Assignment"
                                                        className="assignment-yellow fa fa-pencil"
                                                        aria-hidden="true"
                                                    />
                                                </Link>
                                            </td>
                                            <td>
                                                <Link
                                                    to={`/${dropbox.name}/${spaceToUnderscore(assignment.name)}/copy`}
                                                    onlyActiveOnIndex={false}
                                                >
                                                    <i
                                                        title="Copy Assignment"
                                                        className="assignment-light-blue fa fa-files-o"
                                                        aria-hidden="true"
                                                    />
                                                </Link>
                                            </td>
                                            <td>
                                                <ConfirmLink
                                                    action={deleteAssignmentHandler}
                                                    actionArgs={{
                                                        dropboxId: dropbox.id,
                                                        assignmentId: assignment.id
                                                    }}
                                                    confirmMessage={`Are you sure you want to delete assignment?: ${assignment.name}`}
                                                    confirmText={"Yes"}
                                                    cancelText={"No"}
                                                >
                                                    <i title="Delete Assignment" className="assignment-red fa fa-trash"/>
                                                </ConfirmLink>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        <span className="table-rounded-bottom" />
                        <span>
                            <Link
                                className="btn btn-success btn-sm"
                                to={`/dropbox/${dropbox.id}/assignment/create`}
                                onlyActiveOnIndex={false}
                            >
                                <i className="fa fa-plus-circle"/> Add Assignment
                            </Link>
                        </span>
                        <span className="float-right">
                            <Link
                                className="btn btn-default btn-sm"
                                to={`/dropbox/${dropbox.id}/email_notifications`}
                                onlyActiveOnIndex={false}
                            >
                                <i className="fa fa-envelope"/> Email Notifications
                            </Link>
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}

InstructorHomeView.propTypes = {
    assignments: PropTypes.object.isRequired,
    deleteAssignmentHandler: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    dropbox: PropTypes.object.isRequired,
    dropboxes: PropTypes.array,
    expanded: PropTypes.string,
    request: PropTypes.object.isRequired,
    semesters: PropTypes.object.isRequired
};

export default InstructorHomeView;



/** WEBPACK FOOTER **
 ** ./src/components/InstructorHomeView.js
 **/